var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFile48(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "File 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M39.5331 12.3333H32.25V4.97667L39.5331 12.3333ZM40.5 15.6667V44H7.5V9C7.5 7.67392 8.02152 6.40215 8.94982 5.46447C9.87813 4.52678 11.1372 4 12.45 4H28.95V15.6667H40.5ZM31.6082 26.56L29.28 24.2033L23.3565 30.1783C23.0427 30.4816 22.6251 30.6509 22.1908 30.6509C21.7565 30.6509 21.3389 30.4816 21.025 30.1783L18.4081 27.5367L16.08 29.8933L18.6952 32.535C19.1549 32.9994 19.7006 33.3678 20.3012 33.6191C20.9019 33.8704 21.5456 33.9998 22.1957 33.9998C22.8458 33.9998 23.4896 33.8704 24.0902 33.6191C24.6908 33.3678 25.2365 32.9994 25.6962 32.535L31.6082 26.56Z",
    fill: "url(#paint0_linear_3869_30080)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3869_30080",
    x1: 7.5,
    y1: 4,
    x2: 43.8611,
    y2: 7.3331,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BA1176"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B2BEC"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile48);
export default __webpack_public_path__ + "static/media/File48.d07ed6fa0b7c24520c668bf7ae44814b.svg";
export { ForwardRef as ReactComponent };